import * as AppConstants from "AppConstants";
import { authHeader } from "app/services/auth.header.service";

/**
 * IQMS Service - Quality Management System API calls
 */

// Process Management
export const fetchAllProcesses = async () => {
    const response = await fetch(AppConstants.GET_ALL_PROCESSES_ENDPOINT, {
        method: "GET",
        headers: authHeader(),
    });
    return response.json();
};

export const fetchProcessById = async (processId) => {
    const url = AppConstants.GET_PROCESS_BY_ID_ENDPOINT.replace(AppConstants.PROCESS_ID_PLACEHOLDER, processId);
    const response = await fetch(url, {
        method: "GET",
        headers: authHeader(),
    });
    return response.json();
};

export const createProcess = async (processData) => {
    const response = await fetch(AppConstants.CREATE_PROCESS_ENDPOINT, {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(processData),
    });
    return response.json();
};

export const updateProcess = async (processId, processData) => {
    const url = AppConstants.UPDATE_PROCESS_ENDPOINT.replace(AppConstants.PROCESS_ID_PLACEHOLDER, processId);
    const response = await fetch(url, {
        method: "PUT",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(processData),
    });
    return response.json();
};

export const deleteProcess = async (processId) => {
    const url = AppConstants.DELETE_PROCESS_ENDPOINT.replace(AppConstants.PROCESS_ID_PLACEHOLDER, processId);
    const response = await fetch(url, {
        method: "DELETE",
        headers: authHeader(),
    });
    return response.ok;
};

// Audit Management
export const fetchAllAudits = async () => {
    const response = await fetch(AppConstants.GET_ALL_AUDITS_ENDPOINT, {
        method: "GET",
        headers: authHeader(),
    });
    return response.json();
};

export const fetchAuditById = async (auditId) => {
    const url = AppConstants.GET_AUDIT_BY_ID_ENDPOINT.replace(AppConstants.AUDIT_ID_PLACEHOLDER, auditId);
    const response = await fetch(url, {
        method: "GET",
        headers: authHeader(),
    });
    return response.json();
};

export const createAudit = async (auditData) => {
    const response = await fetch(AppConstants.CREATE_AUDIT_ENDPOINT, {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(auditData),
    });
    return response.json();
};

export const updateAudit = async (auditId, auditData) => {
    const url = AppConstants.UPDATE_AUDIT_ENDPOINT.replace(AppConstants.AUDIT_ID_PLACEHOLDER, auditId);
    const response = await fetch(url, {
        method: "PUT",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(auditData),
    });
    return response.json();
};

export const deleteAudit = async (auditId) => {
    const url = AppConstants.DELETE_AUDIT_ENDPOINT.replace(AppConstants.AUDIT_ID_PLACEHOLDER, auditId);
    const response = await fetch(url, {
        method: "DELETE",
        headers: authHeader(),
    });
    return response.ok;
};

// CAPA Management
export const fetchAllCapa = async () => {
    const response = await fetch(AppConstants.GET_ALL_CAPA_ENDPOINT, {
        method: "GET",
        headers: authHeader(),
    });
    return response.json();
};

export const createCapa = async (capaData) => {
    const response = await fetch(AppConstants.CREATE_CAPA_ENDPOINT, {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(capaData),
    });
    return response.json();
};

// Risk Management
export const fetchAllRisks = async () => {
    const response = await fetch(AppConstants.GET_ALL_RISKS_ENDPOINT, {
        method: "GET",
        headers: authHeader(),
    });
    return response.json();
};

export const createRisk = async (riskData) => {
    const response = await fetch(AppConstants.CREATE_RISK_ENDPOINT, {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(riskData),
    });
    return response.json();
};

